import request from '@/utils/request'

const processApi = {
  getProcessList: '/process/getTask', // 获取流程列表，待办，已办，。。。
  reportMessageForPage: '/auth/online/reportMessageForPage' // 公告列表
}

export function getProcessList(parameter) {
  return request({
    url: processApi.getProcessList,
    method: 'post',
    data: parameter
  })
}

export function reportMessageForPage(parameter) {
  return request({
    url: processApi.reportMessageForPage,
    method: 'post',
    data: parameter
  })
}
